"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBinTypeEnum = void 0;
var CardBinTypeEnum;
(function (CardBinTypeEnum) {
    CardBinTypeEnum["GERMAN_BIN"] = "GERMAN_BIN";
    CardBinTypeEnum["BULGARIAN_BIN"] = "BULGARIAN_BIN";
})(CardBinTypeEnum || (exports.CardBinTypeEnum = CardBinTypeEnum = {}));
